import React, { Component } from 'react'
import './FullCalendar.css';
import Swal from 'sweetalert2'
import { Link } from 'react-router-dom'
import authAxios from '../../services/Token'
import { formatDate } from '@fullcalendar/core'
import esLocale from '@fullcalendar/core/locales/es';
import FullCalendar from '@fullcalendar/react'
import dayGridPlugin from '@fullcalendar/daygrid'
import timeGridPlugin from '@fullcalendar/timegrid'
import interactionPlugin from '@fullcalendar/interaction'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { INITIAL_EVENTS, createEventId } from './event.utils'
import { faAngleDoubleLeft, faAngleDoubleRight, faAngleLeft, faAngleRight, faArrowRight, faEdit, faFilter, faPlus, faTrashAlt, faUsers } from '@fortawesome/free-solid-svg-icons'

class Listar extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            new_title: '',
            paciente: '',
            doctor: '',
            id_paciente: '',
            id_doctor: '',
            animateCreate: false,
            animateInfo: false,
            showCreateModal: false,
            showInfoModal: false,
            selectedInfo: null,
            selectedCita: null,
            weekendsVisible: true,
            currentEvents: [],
            citas: [],
            pacientes: [],
            doctores: [],
            errors: []
        }
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(elemento) {
        return this.state.errors.indexOf(elemento) !== -1;
    }
    handleModalSave = async () => {
        const { selectedInfo, new_title, id_paciente, paciente, id_doctor, doctor } = this.state;
        var errors = [];
        if (!new_title) { errors.push("error_new_title"); }
        if (!paciente) { errors.push("error_paciente"); }
        if (!doctor) { errors.push("error_doctor"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var dataCita = {
            id_paciente: id_paciente,
            id_doctor: id_doctor,
            titulo: new_title,
            fecha_inicio: selectedInfo.startStr,
            fecha_fin: selectedInfo.endStr,
            todo_el_dia: selectedInfo.allDay ? 1 : 0,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const citasDataRes = await authAxios.post("citas/register", dataCita);
            if (!citasDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Citas!',
                citasDataRes.data.message,
                'success'
            );
            const calendarApi = selectedInfo.view.calendar;
            calendarApi.unselect();
            calendarApi.addEvent({
                id: createEventId(),
                title: new_title,
                start: selectedInfo.startStr,
                end: selectedInfo.endStr,
                allDay: selectedInfo.allDay
            })
            this.ListarCitas();
            this.setState({ showCreateModal: false, selectedInfo: null, new_title: '', id_paciente: '', paciente: '', id_doctor: '', doctor: '' })
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    handleModalDelete = () => {
        const cita = this.state.selectedCita;
        const now = new Date();
        const fecha_cita = new Date(cita.fecha_inicio);
        const fecha_hoy = new Date(now.getFullYear(), now.getMonth(), now.getDate());
        const fecha_evento = new Date(fecha_cita.getFullYear(), fecha_cita.getMonth(), fecha_cita.getDate());
        if (fecha_evento < fecha_hoy) {
            Swal.fire("No Permitido", "No puedes eliminar Citas pasadas.", "warning");
            return;
        }
        Swal.fire({
            title: '¿Está seguro de eliminar la Cita?',
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: 'Borrar',
            denyButtonText: `Cancelar`,
        }).then((result) => {
            if (result.isConfirmed) {
                Swal.showLoading();
                authAxios.get(`citas/delete/${cita.id}`)
                    .then((dataResult) => {
                        console.log(dataResult);
                        Swal.fire('Borrado!', 'Cita eliminada con éxito', 'success')
                        this.setState({ showInfoModal: false, selectedCita: null });
                        this.ListarCitas();
                        Swal.close();
                    })
                    .catch(console.log);
            } else if (result.isDenied) {
                Swal.fire('Cancelado', '', 'info')
            }
        })
    }
    handleWeekendsToggle = () => {
        this.setState((prev) => ({ weekendsVisible: !prev.weekendsVisible }))
    }
    // handleDateSelect = (selectInfo) => {
    //     const title = prompt('Please enter a new title for your event')
    //     const calendarApi = selectInfo.view.calendar
    //     calendarApi.unselect()
    //     if (title) {
    //         calendarApi.addEvent({
    //             id: createEventId(),
    //             title,
    //             start: selectInfo.startStr,
    //             end: selectInfo.endStr,
    //             allDay: selectInfo.allDay
    //         })
    //     }
    // }
    handleDateSelect = (selectInfo) => {
        this.setState({ showCreateModal: true }, () => {
            setTimeout(() => this.setState({ animateCreate: true }), 10);
        });
        this.setState({
            selectedInfo: selectInfo,
            new_title: '',
            id_paciente: '',
            paciente: '',
            id_doctor: '',
            doctor: ''
        })
    }
    handleCloseModal = (modal) => {
        switch (modal) {
            case 1:
                this.setState({ animateCreate: false, errors: [] });
                setTimeout(() => this.setState({ showCreateModal: false, selectedInfo: null }), 150);
                break;
            case 2:
                this.setState({ animateInfo: false });
                setTimeout(() => this.setState({ showInfoModal: false, selectedInfo: null }), 150);
                break;
        }
    };
    handleModalChange = (e) => {
        this.setState({ new_title: e.target.value })
    }
    handleEventClick = (clickInfo) => {
        Swal.showLoading();
        const id_cita = clickInfo.event.id;
        this.setState({ selectedCita: null }, () => {
            setTimeout(() => this.setState({ animateInfo: true }), 10);
        });
        authAxios.get('citas/view/' + id_cita)
            .then((dataResult) => {
                console.log("Detalle cita:", dataResult.data.cita);
                this.setState({
                    showInfoModal: true,
                    selectedCita: dataResult.data.cita
                });
                Swal.close();
            })
            .catch((err) => {
                console.error("Error al traer la cita:", err);
                Swal.fire('Error', 'No se pudo cargar la información de la cita', 'error');
            });
    }
    handleEvents = (events) => {
        this.setState({ currentEvents: events })
    }
    selectPaciente = (itemPacientes) => {
        Swal.showLoading();
        this.setState({
            id_paciente: itemPacientes.ID_PACIENTE,
            paciente: itemPacientes.NOMBRE
        });
        Swal.close();
    }
    selectDoctor = (itemDoctores) => {
        Swal.showLoading();
        this.setState({
            id_doctor: itemDoctores.ID_DOCTOR,
            doctor: itemDoctores.NOMBRE
        });
        Swal.close();
    }
    ListarCitas = () => {
        Swal.showLoading();
        authAxios.get("citas/index")
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    this.sessionExpired();
                }
                const events = dataResult.data.map((cita) => ({
                    id: cita.id,
                    title: cita.titulo,
                    start: cita.fecha_inicio ? cita.fecha_inicio.replace(" ", "T") : null,
                    end: cita.fecha_fin ? cita.fecha_fin.replace(" ", "T") : null,
                    allDay: cita.todo_el_dia === 1
                }))
                this.setState({ currentEvents: events })
            })
            .catch(console.log);
    }
    ListarPacientes(page) {
        Swal.showLoading();
        let bname_paciente = document.getElementById('bname_paciente').value;
        if (bname_paciente == '') {
            bname_paciente = 0;
        }
        authAxios.get("pacientes/index/" + bname_paciente + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    pacientes: dataResult.data.data,
                    page_paciente: dataResult.data.total,
                    last_paciente: dataResult.data.last_page,
                    current_paciente: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    ListarDoctores(page) {
        Swal.showLoading();
        let bname_doctor = document.getElementById('bname_doctor').value;
        if (bname_doctor == '') {
            bname_doctor = 0;
        }
        authAxios.get("doctores/index/" + bname_doctor + "?page=" + page)
            .then((dataResult) => {
                console.log(dataResult);
                Swal.close();
                var status = dataResult.status;
                if (!status) {
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({
                    doctores: dataResult.data.data,
                    page_doctor: dataResult.data.total,
                    last_doctor: dataResult.data.last_page,
                    current_doctor: dataResult.data.current_page
                });
            })
            .catch(console.log);
    }
    componentDidMount() {
        this.ListarCitas();
        this.ListarPacientes(1);
        this.ListarDoctores(1);
    }
    render() {
        const {
            weekendsVisible,
            currentEvents,
            showCreateModal,
            showInfoModal,
            new_title,
            id_paciente,
            id_doctor,
            paciente,
            doctor,
            selectedCita,
            page_paciente,
            last_paciente,
            current_paciente,
            page_doctor,
            last_doctor,
            current_doctor,
            pacientes,
            doctores
        } = this.state
        return (
            <div className="content">
                <div className="container-fluid">
                    <br />
                    <div className="card">
                        <div className="card-header">
                            &nbsp;
                        </div>
                        <div className="card-body">
                            <div className="row">
                                {/* <div className="col-xl-2">
                                    <Sidebar
                                        weekendsVisible={weekendsVisible}
                                        handleWeekendsToggle={this.handleWeekendsToggle}
                                        currentEvents={currentEvents}
                                    />
                                </div> */}
                                <div className="col-xl-12">
                                    <div className='demo-app'>
                                        <div className='demo-app-main'>
                                            <FullCalendar
                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                headerToolbar={{
                                                    left: 'prev,next today',
                                                    center: 'title',
                                                    right: 'dayGridMonth,timeGridWeek,timeGridDay'
                                                }}
                                                businessHours={{
                                                    daysOfWeek: [1, 2, 3, 4, 5, 6],
                                                    startTime: '08:00',
                                                    endTime: '23:30'
                                                }}
                                                initialView='dayGridMonth'
                                                editable={true}
                                                selectable={true}
                                                selectAllow={(selectInfo) => {
                                                    const day = selectInfo.start.getDay();
                                                    return day !== 0;
                                                }}
                                                selectMirror={true}
                                                dayMaxEvents={true}
                                                locale={esLocale}
                                                weekends={weekendsVisible}
                                                events={this.state.currentEvents}
                                                select={this.handleDateSelect}
                                                eventContent={renderEventContent}
                                                eventClick={this.handleEventClick}
                                                slotMinTime="08:00:00"
                                                slotMaxTime={"23:30:00"}
                                                allDaySlot={false}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {
                    showCreateModal && (
                        <>
                            <div style={{ display: 'block' }} className={`modal fade ${this.state.animateCreate ? 'show' : ''}`} id="NuevaCitasModal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="NuevaCitasModalLabel" aria-hidden="true">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title w-100 text-center" id="NuevaCitasModalLabel">Nueva Cita</h4>
                                            <button type="button" className="btn-close" onClick={() => this.handleCloseModal(1)}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='row'>
                                                <div className='col-xl-12'>
                                                    <form id="form_item_movement">
                                                        <div className='row g-3'>
                                                            <div className="col-md-12">
                                                                <label htmlFor="new_title">Nueva Cita</label>
                                                                <input style={{ textTransform: 'uppercase' }} type="text" name="new_title" id="new_title" value={new_title}
                                                                    className={((this.errorVerify("error_new_title")) ? "is-invalid" : "") + " form-control form-control-sm"}
                                                                    placeholder="Nueva Cita" aria-describedby="helpId" onChange={this.changeValue} />
                                                                <small id="helpId" className="invalid-feedback">Digite la Nueva Cita</small>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginTop: 0 }} className='row g-3'>
                                                            <div className='col-md-12'>
                                                                <label htmlFor="id_paciente">Paciente</label>
                                                                <div className={((this.errorVerify("error_id_paciente")) ? "is-invalid" : "") + " d-flex"}>
                                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PacientesModal" slot='end'>
                                                                        <FontAwesomeIcon icon={faUsers} />
                                                                    </button>
                                                                    <input type="hidden" name="id_paciente" id="id_paciente" value={id_paciente} />
                                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="paciente" id="paciente" value={paciente} 
                                                                        className={((this.errorVerify("error_paciente")) ? "is-invalid" : "") + " form-control form-control-sm flex-grow-1"} placeholder="Paciente" aria-describedby="helpId"
                                                                        onChange={this.changeValue} readOnly />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Seleccione un Paciente</small>
                                                            </div>
                                                        </div>
                                                        <div style={{ marginTop: 0 }} className='row g-3'>
                                                            <div className='col-md-12'>
                                                                <label htmlFor="id_doctor">Doctor</label>
                                                                <div className={((this.errorVerify("error_id_doctor")) ? "is-invalid" : "") + " d-flex"}>
                                                                    <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#DoctoresModal" slot='end'>
                                                                        <FontAwesomeIcon icon={faUsers} />
                                                                    </button>
                                                                    <input type="hidden" name="id_doctor" id="id_doctor" value={id_doctor} />
                                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="doctor" id="doctor" value={doctor} 
                                                                        className={((this.errorVerify("error_doctor")) ? "is-invalid" : "") + " form-control form-control-sm flex-grow-1"} placeholder="Doctor" aria-describedby="helpId"
                                                                        onChange={this.changeValue} readOnly />
                                                                </div>
                                                                <small id="helpId" className="invalid-feedback">Seleccione un Doctor</small>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.handleCloseModal(1) }>Cancelar</button>
                                            <button type="button" className="btn btn-primary btn-sm" onClick={this.handleModalSave}>Guardar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`modal-backdrop fade ${this.state.animateCreate ? 'show' : ''}`}></div>
                        </>
                    )
                }
                {
                    showInfoModal && (
                        <>
                            <div style={{ display: 'block' }} className={`modal fade ${this.state.animateInfo ? 'show' : ''}`} id="InfoCitasModal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="InfoCitasModalLabel" aria-hidden="true">
                                <div className="modal-dialog" role="document">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title w-100 text-center" id="InfoCitasModalLabel">Información Cita</h4>
                                            <button type="button" className="btn-close" onClick={() => this.handleCloseModal(2)}></button>
                                        </div>
                                        <div className="modal-body">
                                            <div className='row'>
                                                <div className='col-xl-12'>
                                                    {
                                                        selectedCita && (
                                                            <form id="form_item_movement">
                                                                <div className='row g-3'>
                                                                    <label className="col-md-2 col-form-label">Cita</label>
                                                                    <div className="col-md-10">
                                                                        <label style={{ fontWeight: 'normal' }} className="col-form-label">{selectedCita.titulo}</label>
                                                                    </div>
                                                                </div>
                                                                <div className='row g-3'>
                                                                    <label className="col-md-2 col-form-label">Paciente</label>
                                                                    <div className="col-md-10">
                                                                        <label style={{ fontWeight: 'normal' }} className="col-form-label">{selectedCita.PACIENTE}</label>
                                                                    </div>
                                                                </div>
                                                                <div className='row g-3'>
                                                                    <label className="col-md-2 col-form-label">Doctor</label>
                                                                    <div className="col-md-10">
                                                                        <label style={{ fontWeight: 'normal' }} className="col-form-label">{selectedCita.DOCTOR}</label>
                                                                    </div>
                                                                </div>
                                                                <div className='row g-3'>
                                                                    <label className="col-md-2 col-form-label">Desde</label>
                                                                    <div className="col-md-10">
                                                                        <label style={{ fontWeight: 'normal' }} className="col-form-label">{selectedCita.fecha_inicio}</label>
                                                                    </div>
                                                                </div>
                                                                <div className='row g-3'>
                                                                    <label className="col-md-2 col-form-label">Hasta</label>
                                                                    <div className="col-md-10">
                                                                        <label style={{ fontWeight: 'normal' }} className="col-form-label">{selectedCita.fecha_fin}</label>
                                                                    </div>
                                                                </div>
                                                            </form>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="modal-footer">
                                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => this.handleCloseModal(2) }>Cancelar</button>
                                            <button type="button" className="btn btn-danger btn-sm" onClick={this.handleModalDelete}>Borrar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={`modal-backdrop fade ${this.state.animateInfo ? 'show' : ''}`}></div>
                        </>
                    )
                }
                <div className="modal fade" id="PacientesModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PacientesModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PacientesModalLabel">Pacientes</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-10">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bname_paciente" name="bname_paciente" placeholder="Buscar Paciente" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PACIENTE</th>
                                                    <th className="align-middle">IDENTIFICACIÓN</th>
                                                    <th className="align-middle">CELULAR</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    pacientes.map((itemPacientes) => (
                                                        <tr key={itemPacientes.ID_PACIENTE}>
                                                            <td>{itemPacientes.NOMBRE}</td>
                                                            <td>{itemPacientes.IDENTIFICACION}</td>
                                                            <td>{itemPacientes.CELULAR}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectPaciente(itemPacientes)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul style={{ marginBottom: 0 }} className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_paciente - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={current_paciente}><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_paciente)}>{current_paciente}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(current_paciente + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarPacientes(last_paciente)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div style={{ justifyContent: 'left' }} className="modal-footer text-muted">
                                <b>Page</b> <span className="badge bg-primary">{current_paciente}</span> <b>of</b> <span className="badge bg-primary">{last_paciente}</span> | <b>Records</b> <span className="badge bg-success">{page_paciente}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="DoctoresModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="DoctoresModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="DoctoresModalLabel">Doctores</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className="row">
                                    <div className="col-xl-10">
                                        <input style={{ textTransform: 'uppercase' }} type="text" id="bname_doctor" name="bname_doctor" placeholder="Buscar Doctor" className="form-control form-control-sm" />
                                    </div>
                                    <div className="col-xl-2">
                                        <button id="bt" name="bt" className="btn btn-secondary btn-sm" onClick={() => this.ListarDoctores(1)}><FontAwesomeIcon icon={faFilter} />&nbsp;&nbsp;Filtrar</button>
                                    </div>
                                </div>
                                <br />
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">DOCTOR</th>
                                                    <th className="align-middle">IDENTIFICACIÓN</th>
                                                    <th className="align-middle">ESPECIALIDAD</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    doctores.map((itemDoctores) => (
                                                        <tr key={itemDoctores.ID_DOCTOR}>
                                                            <td>{itemDoctores.NOMBRE}</td>
                                                            <td>{itemDoctores.IDENTIFICACION}</td>
                                                            <td>{itemDoctores.ESPECIALIDAD}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.selectDoctor(itemDoctores)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <nav aria-label="Page navigation example">
                                    <ul style={{ marginBottom: 0 }} className="pagination">
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarDoctores(1)}><FontAwesomeIcon icon={faAngleDoubleLeft} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarDoctores(current_doctor - 1)}><FontAwesomeIcon icon={faAngleLeft} /></a></li>
                                        {(() => {
                                            let p = [];
                                            p.push(<li className="page-item" key={current_doctor}><a className="page-link" href="#" onClick={() => this.ListarDoctores(current_doctor)}>{current_doctor}</a></li>);
                                            return p;
                                        })()}
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarDoctores(current_doctor + 1)}><FontAwesomeIcon icon={faAngleRight} /></a></li>
                                        <li className="page-item"><a className="page-link" href="#" onClick={() => this.ListarDoctores(last_doctor)}><FontAwesomeIcon icon={faAngleDoubleRight} /></a></li>
                                    </ul>
                                </nav>
                            </div>
                            <div style={{ justifyContent: 'left' }} className="modal-footer text-muted">
                                <b>Page</b> <span className="badge bg-primary">{current_doctor}</span> <b>of</b> <span className="badge bg-primary">{last_doctor}</span> | <b>Records</b> <span className="badge bg-success">{page_doctor}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function renderEventContent(eventInfo) {
    return (
        <>
            <b>{eventInfo.timeText}</b>&nbsp;
            <i>{eventInfo.event.title}</i>
        </>
    )
}
  
  class Sidebar extends Component {
    render() {
      // Defensa por si algo llega undefined
      const { weekendsVisible, handleWeekendsToggle } = this.props
      const safeEvents = Array.isArray(this.props.currentEvents)
        ? this.props.currentEvents
        : []
  
        return (
            <div className="demo-app-sidebar">
                <div className="demo-app-sidebar-section">
                    <h2>Citas ({safeEvents.length})</h2>
                    <ul>
                    {safeEvents.map((event) => (
                        <SidebarEvent key={event.id} event={event} />
                    ))}
                    </ul>
                </div>
            </div>
        )
    }
}
  
class SidebarEvent extends Component {
    render() {
        const { event } = this.props
        return (
            <li key={event.id}>
            <b>
                {formatDate(event.start, {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                })}
            </b>&nbsp;
            <i>{event.title}</i>
            </li>
        )
    }
}

export default Listar;